import { get } from 'lodash';
import queryString from 'query-string';
import urlCatalog from '@angi/url-catalog';
import { httpClient } from 'angieslist-app-platform';
import createAppInjectors from 'angieslist-app-platform/lib/createAppInjectors';
import displayPreferencesReducer from 'angieslist-app-platform/lib/common/displayPreferences/displayPreferencesReducer';
import { getDisplayPreferences } from 'angieslist-app-platform/lib/common/displayPreferences/displayPreferencesActions';
import { getUser } from './app/common/user/userActions';
import appReducer from './app/common/appReducer';
import { setBusinessCenterPhone } from './app/common/appActions';
import agreementReducer from './app/common/agreement/agreementReducer';
import { serviceProviderCache, serviceProviderId, leadServiceProvider, spProductPackage, proProductPackage } from './app/common/serviceProvider/serviceProviderReducer';
import userReducer from './app/common/user/userReducer';
import analyticsReducer from './app/common/analytics/analyticsReducer';
import advertiseReducer from './app/common/advertise/advertiseReducer';
import TargetMetricEvents from './app/common/targetMetrics';
import serviceProviderProfile from './modules/profile/common/profileReducer';
import images from './modules/store/common/imagesReducer';
import proAuthReducer from './app/common/auth/proAuthReducer';
import accountSyncReducer from './modules/sync/common/accountSyncReducer';
import businessListReducer from './modules/home/common/businessListReducer';
import inboxReducer from './modules/inbox/common/inboxReducer';
import categoryGroupReducer from './app/common/category-group/categoryGroupReducer';
import adAgreementReducer from './modules/adAgreement/common/adAgreementReducer';


// Return an injectors object that extends baseAppInjector
export default createAppInjectors({
  beforePageMounted: () => {
    // set the Csrf-token to no check for scala play form requests
    httpClient.getConfig().headers['Csrf-Token'] = 'nocheck';
    if (process.env.IS_BROWSER) {
      // eslint-disable-next-line
      const { initTargetSegmentIntegration } = require('angieslist-app-platform/lib/common/analytics/target/TargetSegmentIntegration');
      initTargetSegmentIntegration(TargetMetricEvents);
    }
  },
  beforeConfigureStore: (options, props = {}) => {
    const storeOptions = {
      reducers: {
        ...(options || {}).reducers,
        app: appReducer,
        // get signed legal contracts status and enforce signing the latest contracts
        // for authorized pages
        agreement: agreementReducer(props.authorized, props.deferLegalRedirect),
        serviceProviderCache,
        serviceProviderId,
        leadServiceProvider,
        user: userReducer,
        displayPreferences: displayPreferencesReducer,
        advertise: advertiseReducer,
        serviceProviderProfile,
        spProductPackage,
        proProductPackage,
        images,
        inbox: inboxReducer,
        customAnalytics: analyticsReducer,
        proAuth: proAuthReducer,
        accountSync: accountSyncReducer,
        businessList: businessListReducer,
        categoryGroup: categoryGroupReducer,
        adAgreement: adAgreementReducer,
      },
    };

    // Configure which reducers should be persisted
    ['agreement', 'serviceProviderCache', 'user'].forEach((k) => {
      storeOptions.reducers[k].persist = true;
    });

    return storeOptions;
  },
  afterConfigureStore: (store, props = {}) => {
    if (!props.noUser && process.env.IS_BROWSER) {
      store.dispatch(getUser());
    }
    httpClient.addInterceptor({
      request: (request) => {
        request.headers.set('X-ANGI-CallerType', 'ServiceProvider');
        if (request.url.includes('proapi')) {
          const storeState = store.getState();
          request.headers.set('X-ANGI-CallerId', storeState.serviceProviderId);
        }
        return request;
      },
    });
    urlCatalog.initialize({
      baseUrls: {
        member: store.getState().config.memberUrl,
        office: store.getState().config.officeUrl,
      },
    });
    if (process.env.IS_BROWSER) {
      store.dispatch(getDisplayPreferences());

      // eslint-disable-next-line no-undef
      const contactId = get(queryString.parse(window.location.search), 'contact_id', '');
      const businessCenterPhone = urlCatalog.global.businessCenterPhoneByContactId(contactId);
      store.dispatch(setBusinessCenterPhone(businessCenterPhone));
    }
  },
});



// WEBPACK FOOTER //
// ./src/appInjectors.js